import React from 'react';

function PulseLogo({ variant = 'light', size = 'medium', showTagline = true, companyName, logoUrl }) {
    const sizes = {
        small: { icon: 28, text: 16, tagline: 9, gap: 8 },
        medium: { icon: 40, text: 22, tagline: 11, gap: 12 },
        large: { icon: 56, text: 28, tagline: 13, gap: 16 }
    };
    const currentSize = sizes[size] || sizes.medium;
    const isDark = variant === 'dark';
    const textColor = isDark ? '#ffffff' : '#1a237e';
    const textColorSpan = isDark ? '#00bcd4' : '#00bcd4';
    const taglineColor = isDark ? '#aaa' : '#666';
    const box = currentSize.icon + 12;

    return (
        <div className="d-inline-flex align-items-center" style={{ gap: currentSize.gap, textDecoration: 'none' }}>
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={companyName || 'Company logo'}
                    style={{
                        width: box,
                        height: box,
                        objectFit: 'contain',
                        borderRadius: 12,
                        background: isDark ? '#0b1220' : '#fff',
                        padding: 2
                    }}
                />
            ) : (
                <div style={{
                    width: box,
                    height: box,
                    background: isDark ? 'linear-gradient(135deg, #00bcd4, #1a237e)' : 'linear-gradient(135deg, #1a237e, #00bcd4)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                }}>
                    <svg viewBox="0 0 24 24" width={currentSize.icon} height={currentSize.icon} fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="4,14 8,14 10,10 12,16 14,6 16,14 20,14"/>
                        <circle cx="14" cy="6" r="1.5" fill="white" stroke="none"/>
                    </svg>
                </div>
            )}
            <div>
                <div style={{ fontSize: currentSize.text, fontWeight: 700, color: textColor, letterSpacing: '-0.5px' }}>
                    {companyName ? companyName : <>Pulse <span style={{ color: textColorSpan }}>Insurance</span></>}
                </div>
                {showTagline && (
                    <div style={{ fontSize: currentSize.tagline, color: taglineColor, letterSpacing: '1px', textTransform: 'uppercase', marginTop: '-2px' }}>
                        {companyName ? 'Pulse Insurance Platform' : 'Protecting Your Future'}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PulseLogo;
